export default ['userService', 'adSegmentsService', function (userService, adSegmentsService) {
  this.setSegmentVisible = adSegmentsService.setSegmentVisible;
  this.isSegmentHidden = adSegmentsService.isSegmentHidden;

  this.getUserBalance = () => userService.user.balance;

  this.getAgencyBalance = () => userService.user.agencyBalance;

  this.isSubAgent = () => userService.user.isSubAgent;

  this.getSubAgentMoneySource = () => userService.user.moneySource;

  this.getUserTariff = () => {
    let result = '';
    if (userService.user && userService.user.billingInfo &&
        userService.user.billingInfo.packages && userService.user.billingInfo.packages[0]) {
      result = userService.user.billingInfo.packages[0].packageTypeName + ' (' +
          userService.user.billingInfo.packages[0].geoName + ')';
    }
    return result;
  };
}];
